import React, { Component } from 'react';
import s from './PageLinks.css';

export default class PageLinks extends Component {
  render(){
    const links = [
      {title: "プロフィール", id:"profile"},
      {title: "技術", id:"tech"},
      {title: "職歴/実績" , id:"history"},
      {title: "アピール", id:"appeal"},
    ];
    return pug`
      div(className=s.links)
        each link,i in links
          a(key=i className=s.link href=("#" + link.id))= link.title + " "
          if(i != links.length-1)
            | | 
          
    `;
  }
}



// WEBPACK FOOTER //
// ./src/PageLinks.js